"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClearSimilarProductsSelectionUseCase = void 0;
const react_1 = require("react");
const repositories_1 = require("../../repositories");
/**
 * Caso de uso que limpa a seleção de produtos similares. Útil na finalização de pedidos.
 */
function useClearSimilarProductsSelectionUseCase() {
    const similarProductsRepository = (0, react_1.useMemo)(() => new repositories_1.SimilarProductsRepository(), []);
    const call = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        return similarProductsRepository.removeAll();
    }), [similarProductsRepository]);
    return call;
}
exports.useClearSimilarProductsSelectionUseCase = useClearSimilarProductsSelectionUseCase;
